import { render, staticRenderFns } from "./supply-company-info-check-new.vue?vue&type=template&id=f80c12bc&scoped=true&"
import script from "./supply-company-info-check-new.vue?vue&type=script&lang=js&"
export * from "./supply-company-info-check-new.vue?vue&type=script&lang=js&"
import style0 from "./supply-company-info-check-new.vue?vue&type=style&index=0&id=f80c12bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80c12bc",
  null
  
)

export default component.exports